import PropTypes from 'prop-types';
import { FiTrash, FiX } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import {
  PrimaryButton,
  PrimaryOutlineButton,
} from '../button/button-component';
import Styled from './card-style';
import PermissionWrapper from '../permission-wrapper/permission-wrapper-component';

/**
 * Card component.
 * @param {object} props The props.
 * @returns {JSX.Element} The rendered Card component.
 */
const SubmitCard = (props) => {
  const {
    primaryButtonTitle,
    primaryButtonType,
    primaryButtonDisabled,
    primaryButtonWidth,
    primaryPermission,
    visible,
    isLoading,
    submitClick,
    secondaryButtonDisabled,
    secondaryButtonTitle,
    secondaryButtonWidth,
    secondaryButtonType,
    secondaryPermission,
    submitClickSecondary,
    className,
    headerTitle,
    HeaderIcon,
    disabled,
    width,
    height,
    showPrimaryButton,
    showSecondaryButton,
    backgroundColor,
    padding,
    onClick,
    paddingHeader,
    hoverColor,
    margin,
    cursor,
    hover,
    marginHeader,
    borderRadius,
    bodyStyle,
    fixToBottom,
  } = props;
  const navigate = useNavigate();
  return (
    <Styled.Card
      $visible={visible}
      $padding={padding}
      $borderRadius={borderRadius}
      $width={width}
      $height={height}
      $hoverColor={hoverColor}
      $margin={margin}
      $cursor={cursor}
      $hover={hover}
      onClick={onClick}
      $backgroundColor={backgroundColor}
      className={disabled ? 'disabled' : className}
      $fixToBottom={fixToBottom}
    >
      {className === 'editMode' ? (
        <Styled.EditModeStyle>
          <span>Edit Mode</span>
        </Styled.EditModeStyle>
      ) : null}
      {headerTitle && (
        <Styled.CardHeader
          $paddingHeader={paddingHeader}
          $marginHeader={marginHeader}
        >
          {HeaderIcon && <HeaderIcon size={22} />}
          {headerTitle && <span>{headerTitle}</span>}
        </Styled.CardHeader>
      )}
      <Styled.CardBody $padding={padding} style={bodyStyle}>
        <Styled.RowStyle>
          {showSecondaryButton &&
            (secondaryPermission ? (
              <PermissionWrapper
                permissions={secondaryPermission}
                fallback={
                  <PrimaryOutlineButton
                    buttonWidth={secondaryButtonWidth}
                    icon={<FiX />}
                    disabled={secondaryButtonDisabled}
                    margin="0 0 0 0"
                    type={secondaryButtonType}
                    loading={false}
                    title="Cancel"
                    onClick={() => navigate(-1)}
                  />
                }
              >
                <PrimaryOutlineButton
                  buttonWidth={secondaryButtonWidth}
                  icon={
                    secondaryButtonTitle === 'Delete' ? <FiTrash /> : <FiX />
                  }
                  disabled={secondaryButtonDisabled}
                  margin="0 0 0 0"
                  type={secondaryButtonType}
                  loading={isLoading}
                  title={secondaryButtonTitle}
                  onClick={submitClickSecondary}
                />
              </PermissionWrapper>
            ) : (
              <PrimaryOutlineButton
                buttonWidth={secondaryButtonWidth}
                icon={secondaryButtonTitle === 'Delete' ? <FiTrash /> : <FiX />}
                disabled={secondaryButtonDisabled}
                margin="0 0 0 0"
                type={secondaryButtonType}
                loading={isLoading}
                title={secondaryButtonTitle}
                onClick={submitClickSecondary}
              />
            ))}
          <Styled.Bumper />
          {showPrimaryButton &&
            (primaryPermission ? (
              <PermissionWrapper permissions={primaryPermission}>
                <PrimaryButton
                  buttonWidth={primaryButtonWidth}
                  disabled={primaryButtonDisabled}
                  type={primaryButtonType}
                  loading={isLoading}
                  title={primaryButtonTitle}
                  onClick={submitClick}
                />
              </PermissionWrapper>
            ) : (
              <PrimaryButton
                buttonWidth={primaryButtonWidth}
                disabled={primaryButtonDisabled}
                type={primaryButtonType}
                loading={isLoading}
                title={primaryButtonTitle}
                onClick={submitClick}
              />
            ))}
        </Styled.RowStyle>
      </Styled.CardBody>
    </Styled.Card>
  );
};

SubmitCard.propTypes = {
  primaryButtonTitle: PropTypes.string,
  primaryButtonType: PropTypes.string,
  submitClick: PropTypes.func,
  submitClickSecondary: PropTypes.func,
  primaryButtonDisabled: PropTypes.bool,
  visible: PropTypes.bool,
  secondaryButtonDisabled: PropTypes.bool,
  secondaryButtonWidth: PropTypes.string,
  secondaryButtonType: PropTypes.string,
  secondaryButtonTitle: PropTypes.string,
  primaryButtonWidth: PropTypes.string,
  secondaryPermission: PropTypes.array,
  primaryPermission: PropTypes.array,
  paddingHeader: PropTypes.string,
  marginHeader: PropTypes.string,
  borderRadius: PropTypes.string,
  isLoading: PropTypes.bool,
  backgroundColor: PropTypes.string,
  hoverColor: PropTypes.string,
  hover: PropTypes.bool,
  headerTitle: PropTypes.string,
  HeaderIcon: PropTypes.node,
  width: PropTypes.string,
  margin: PropTypes.string,
  cursor: PropTypes.string,
  showPrimaryButton: PropTypes.bool,
  showSecondaryButton: PropTypes.bool,
  height: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  padding: PropTypes.string,
  bodyStyle: PropTypes.shape({}),
  fixToBottom: PropTypes.bool,
};

SubmitCard.defaultProps = {
  hoverColor: '#fff',
  HeaderIcon: null,
  cursor: 'pointer',
  margin: '0',
  height: 'auto',
  width: '100%',
  hover: false,
  primaryButtonDisabled: false,
  visible: false,
  primaryButtonTitle: 'Submit',
  primaryButtonType: 'submit',
  submitClick: () => {},
  submitClickSecondary: () => {},
  primaryButtonWidth: '112px',
  secondaryButtonTitle: 'Delete',
  isLoading: false,
  showPrimaryButton: true,
  showSecondaryButton: true,
  secondaryButtonType: 'button',
  secondaryButtonDisabled: false,
  secondaryButtonWidth: '112px',
  paddingHeader: '0px',
  marginHeader: undefined,
  borderRadius: ' 0 0 4px 4px',
  backgroundColor: '#FFFFFF',
  headerTitle: undefined,
  className: '',
  padding: '',
  onClick: undefined,
  disabled: false,
  bodyStyle: {},
  secondaryPermission: undefined,
  primaryPermission: undefined,
  fixToBottom: false,
};

export default SubmitCard;
